var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ra-summary--card"},[_c('div',{staticClass:"rd-summary--card__text"},[_c('p',[_vm._v(_vm._s(_vm.label))]),_vm._t("value",function(){return [_c('h4',[_vm._v(_vm._s(_vm.value))])]})],2),_c('div',{staticClass:"rd-summary--card__action"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }